export default __webpack_public_path__ + "static/media/The_Right_Way_to_Cloud_Compute_Lessons_Learnt_at_Opsgenie_Atlas_Camp_Austria.1828126b.png";